import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { SIDEBAR_ACCESS_BY_GROUP, DEFAULT_ACCESS } from '@/config/sidebarPermissions'
import type { SidebarItemId } from '@/config/sidebarPermissions'

/**
 * Guard para verificar autenticação e autorização
 */
export function authGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authStore = useAuthStore()
  
  // Verificar se precisa estar autenticado
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
    return
  }
  
  // Verificar se é rota somente para convidados
  if (to.meta.requiresGuest && authStore.isAuthenticated) {
    next('/dashboard')
    return
  }
  
  // Verificar papel/role específico
  if (to.meta.requiresRole && authStore.user && !authStore.user.roles.includes(to.meta.requiresRole as string)) {
    next('/dashboard')
    return
  }

  // Verificar permissão de item (controle por grupos)
  // Coletar itens exigidos pelas rotas correspondentes (mais específico por último)
  const requiredItems = to.matched
    .map(r => r.meta.requiredItem as SidebarItemId | undefined)
    .filter(Boolean) as SidebarItemId[]

  if (requiredItems.length) {
    const roles = (authStore.user?.roles || []).map(r => String(r).toLowerCase())
    const group = roles.includes('internal') ? 'internal' : roles.includes('external') ? 'external' : null
    const allowed = group ? SIDEBAR_ACCESS_BY_GROUP[group] : DEFAULT_ACCESS
    const isAllAllowed = requiredItems.every(item => allowed.includes(item))
    if (!isAllAllowed) {
      next('/dashboard')
      return
    }
  }
  
  next()
}